var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5401 2.06002C14.4724 1.64666 15.5276 1.64666 16.4599 2.06002L27.2494 6.84425C29.7189 7.93926 28.9629 11.75 26.2762 11.75H3.72383C1.03709 11.75 0.281114 7.93925 2.75059 6.84425L13.5401 2.06002ZM15.4866 4.40956C15.1759 4.27177 14.8241 4.27177 14.5134 4.40956L4.26345 8.9544C4.13997 9.00915 4.17905 9.19367 4.31412 9.19367H25.6859C25.8209 9.19367 25.86 9.00915 25.7365 8.9544L15.4866 4.40956Z",
    fill: "#FDF4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 28C2.5 27.3096 3.05964 26.75 3.75 26.75H26.25C26.9404 26.75 27.5 27.3096 27.5 28C27.5 28.6904 26.9404 29.25 26.25 29.25H3.75C3.05964 29.25 2.5 28.6904 2.5 28Z",
    fill: "#FDF4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 24.25C13.75 24.9404 14.3096 25.5 15 25.5C15.6904 25.5 16.25 24.9404 16.25 24.25V14.25C16.25 13.5596 15.6904 13 15 13C14.3096 13 13.75 13.5596 13.75 14.25V24.25Z",
    fill: "#FDF4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 25.5C6.80964 25.5 6.25 24.9404 6.25 24.25L6.25 14.25C6.25 13.5596 6.80964 13 7.5 13C8.19036 13 8.75 13.5596 8.75 14.25L8.75 24.25C8.75 24.9404 8.19036 25.5 7.5 25.5Z",
    fill: "#FDF4F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 24.25C21.25 24.9404 21.8096 25.5 22.5 25.5C23.1904 25.5 23.75 24.9404 23.75 24.25V14.25C23.75 13.5596 23.1904 13 22.5 13C21.8096 13 21.25 13.5596 21.25 14.25V24.25Z",
    fill: "#FDF4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.2b5b4185e8a3985b1f3e1025224c466f.svg";
export { ForwardRef as ReactComponent };